<div class="row">
    <div class="col-12">
        <div class="blocks m-3 pt-0 px-0">


            <div class="row px-3">
                <div class="col-12">
                    <div class="m-3">
                        <i class="far fa-user fa-lg mr-5"></i>
                        <label class="form-label label-fw"> Dati personali</label>
                    </div>
                </div>
            </div>
            <div class="row px-3">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="m-3">
                        <label class="form-label label-fw">Email</label>
                        <span class="sub-menu form-control form-fw view-i m-0">{{view.email}}</span>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="m-3">
                        <label class="form-label label-fw">Telefono</label>
                        <span class="sub-menu form-control form-fw view-i m-0">{{view.telephone}}</span>
                    </div>
                </div>
            </div>
            <div class="row px-3">
                <div class="col-12">
                    <div class="m-3 border-b"></div>
                </div>
            </div>

            <div class="row px-3">
                <div class="col-12">
                    <div class="m-3">
                        <i class="far fa-info-circle fa-lg mr-5"></i>
                        <label class="form-label label-fw"> Dettaglio</label>
                    </div>
                </div>
            </div>
            <div class="row px-3">
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="m-3">
                        <label class="form-label label-fw">COMSY store</label>
                        <span class="sub-menu form-control form-fw view-i m-0">{{view.storeComsy}}</span>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="m-3">
                        <label class="form-label label-fw">Store di riferimento </label>
                        <span class="sub-menu form-control form-fw view-i m-0">{{view.storeCity}}</span>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="m-3">
                        <label class="form-label label-fw">Indirizzo Store</label>
                        <span class="sub-menu form-control form-fw view-i m-0">{{view.storeAddress}}</span>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="m-3">
                        <label class="form-label label-fw">Data appuntamento</label>
                        <span class="sub-menu form-control form-fw view-i m-0">{{view.reservationDate}}</span>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" *ngIf="(view.flgConsentCommMktgLead!=null)">
                    <div class="m-3">
                        <label class="form-label label-fw">Flag Consenso</label>
                        <span *ngIf="view.flgConsentCommMktgLead" class="sub-menu form-control form-fw view-i m-0">
                            Attivo
                        </span>
                        <span *ngIf="!view.flgConsentCommMktgLead" class="sub-menu form-control form-fw view-i m-0">
                            Non Attivo
                        </span>
                        {{flgConsentCommMktgLead}}
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="m-3">
                        <label class="form-label label-fw">Url pagina</label>
                        {{view.pageUrl}}
                    </div>
                </div>
            </div>


            <!--Buttons-->
            <div class="row">
                <div class="col-12">
                    <div class="my-4 pt-5 text-center">
                        <button (click)="clickButtonCancel()" type="button"
                            class="btn btn-outline-warning btn-outline-fw text">Indietro</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>